export default __webpack_public_path__ + "static/media/peach_fruit.347c29bd.svg";